import { useSetState } from 'ahooks';
import { message, Button } from 'antd';
import { SActionBtn, SBack, SLowcodeList, STableActions, SDrawer, SMessage  } from 'shj-components'
import { get } from 'lodash-es';
import React, { useEffect, useRef, createRef } from 'react';
import KeepAlive from 'react-activation';
// import { EditModal } from './edit';
import { useLocation } from "react-router-dom";
import { AddOrEditForm } from './edits'
import { esignCommonFindCompanyConfig, esignCommonApply, esignCommonDealetCompny, esignCommonUpdateById, esignCommonSaveOrUpdateCompny } from '@/services/fmsConfig'
import { httpCompanyList, getEnumEsign } from '@/services/fmsServices'
function CompanyApply(props: any) {
  let listRef = useRef<any>();
  const childRef = createRef<any>()
  const [state, setState] = useSetState<any>({
    editVisible: false,
    authVisible: false,
    submitLoading: false,
    editTitle: '',
    editItem: {},
    companyList: [],
    taxPayerTypeList: [],
    formDisabled: false,
    financialOrgList: [],
  });

  useEffect(() => {
    fetchCompany();
    getFinancialOrgList();
  }, []);

  const fetchList = ({ query, current, pageSize }: any) => {
    const params = {
      ...query,
      srcSystemCode: 'CAAS',
    };

    if (!params.companyFullName) {
      delete params.companyFullName;
    }
    if (!params.financialOrgName) {
      delete params.financialOrgName;
    }
    return esignCommonFindCompanyConfig(current, pageSize, params).then((res: any) => {
        const { records, total } = res;
        return { records, total };
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const fetchCompany = async () => {
    const companyLists = await httpCompanyList()
    const taxPayerTypeLists = await getEnumEsign('com.shj.saas.esign.enums.TaxPayerType')
    setState({ companyList:companyLists, taxPayerTypeList: taxPayerTypeLists });
  };
  const getFinancialOrgList = () => {
    // 没有用到
    // queryKdCompanyInfo({
    //   fnumber: '',
    //   limit: 2000,
    //   queryKey: '',
    //   startRow: 0,
    //   topRowCount: 0,
    // }).then((res: any) => {
    //     const financialOrgList = res;
    //     setState({ financialOrgList });
    //   });
  };

  const onAdd = () => {
    setState({ editVisible: true, editTitle: '新增', editItem: {}, formDisabled: false });
  };

  const onEdit = (record: any, bol) => {
    setState({ editVisible: true, editTitle: `编辑`, editItem: record, formDisabled: false, authVisible: bol});
  };
  const onUpdateById = (record: any) => {
    esignCommonUpdateById({id: record.id, state: '-1'}).then((res: any) => {
      message.success(res.message || '操作成功');
      listRef.current && listRef.current.reload();
    }).catch((error: any) => {
      listRef.current && listRef.current.reload();
    });
  };

  const onPreview = (record: any) => {
    setState({ editVisible: true, editTitle: `查看`, editItem: record, formDisabled: true });
  };
  const onApply = (record: any) => {
    let dialog = SMessage.confirm({
      title: '是否提交审核？',
      content: '是否确认提交审核？',
      onOk: () => {
        esignCommonApply(record.id).then((res: any) => {
          message.success('发起成功');
          listRef.current && listRef.current.reload();
        }).catch((error: any) => {
          listRef.current && listRef.current.reload();
        });
        dialog?.destroy();
      },
      onCancel: (close) => {
        close();
      },
    });
  }

  const onDelete = (record: any) => {
    let dialog = SMessage.delete({
      onOk: () => {
        esignCommonDealetCompny(record.id).then((res: any) => {
          const msg = get(res, 'data.msg') || '删除成功';
          if (msg) {
            message.success(msg);
          }
          listRef.current && listRef.current.reload();
        });
        dialog?.destroy();
      },
      onCancel: () => {
        dialog?.destroy();
      },
    });
  };

  const onSubmitOk = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      // 优化日期格式化和标志设置
      setState({ submitLoading: true });
      values.srcSystemCode = 'CAAS';
      values.autoSign = !!values.autoSign;
      const getFilePath = (file: any) => get(file[0], 'response.data.filePath') || get(file[0], 'filePath');
      const fileFields = ['financialSealFile', 'identityFile', 'sealFile', 'siagnApplication'];
      fileFields.forEach(field => {
        if (values[field]) {
          values[field] = getFilePath(values[field]);
        }
      });
      esignCommonSaveOrUpdateCompny(values).then((res: any) => {
          // console.log(res);
          const msg = get(res, 'message') || '';
          if (get(res, 'sucessFlag') === true) {
            setState({ submitLoading: false });
            setState({ editVisible: false });
            listRef.current && listRef.current.reload();
            if (msg) {
              message.success(msg);
            }
          } else {
            if (msg) {
              message.error(msg);
            }
          }
        })
        .catch((err: any) => {
          setState({ submitLoading: false });
        });
    })
  };

  const extension = {
    request: {
      fetchList,
      //getStatusOptions
    },
    events: {
      onAdd,
    },
    customRender: {},
  };

  return (
    <>
      <SLowcodeList
        searchMode="group"
        config={{
          rowSelection: false,
          columns: [
            {
              title: '财务主体编码',
              dataIndex: 'financialOrgCode',
              width: 140,
              ellipsis: true,
            },
            {
              title: '财务主体',
              dataIndex: 'companyFullName',
              width: 200,
              ellipsis: true,
            },
            {
              title: '纳税人识别号',
              dataIndex: 'companyIdentityNum',
              width: 200,
              ellipsis: true,
            },
            {
              title: '法人名称',
              dataIndex: 'identityName',
              width: 100,
              ellipsis: true,
            },
            {
              title: '法人证件号码',
              dataIndex: 'identityCardCode',
              width: 200,
              ellipsis: true,
            },
            {
              title: '是否自动签名',
              dataIndex: 'autoSign',
              width: 120,
              render: (text: any, record: any) => {
                return text ? '是' : '否';
              },
            },
            {
              title: '公司邮箱',
              dataIndex: 'email',
              width: 200,
              ellipsis: true,
            },
            {
              title: '联系电话',
              dataIndex: 'mobile',
              width: 140,
              ellipsis: true,
            },
            {
              title: '公司地址',
              dataIndex: 'companyAddress',
              ellipsis: true,
              width: 300,
            },
            {
              title: '申请错误描述',
              dataIndex: 'errorMessage',
              ellipsis: true,
              width: 300,
            },
            {
              title: '状态',
              dataIndex: 'state',
              fixed: 'right',
              width: 100,
              render: (text: any, record: any) => {
                return (
                  { '-1': '未提审核', '0': '审核中', '1': '审核通过', '2': '审核不通过', '3': '身份认证通过' }[text] ||
                  ''
                );
              },
            },
            {
              "title": "创建人",
              "dataIndex": "createdByName",
              "ellipsis": true,
              "width": 100
            },
            {
              "title": "创建日期",
              "dataIndex": "createdTime",
              "itemType": "dateTime",
              "width": 170
            },
            {
              "title": "修改人",
              "dataIndex": "modifiedByName",
              "ellipsis": true,
              "width": 100
            },
            {
              "title": "修改日期",
              "dataIndex": "lastUpdatedTime",
              "itemType": "dateTime",
              "width": 170
            },
            {
              title: '操作',
              dataIndex: 'actions',
              width: 202,
              render: (text: any, record: any) => {
                return (
                  <STableActions>
                    {['0', '1'].includes(record.state) ? (
                      <SActionBtn onClick={() => onPreview(record)}>查看</SActionBtn>
                    ) : null}
                    {['1'].includes(record.state) ? (
                      // <SActionBtn onClick={() => onUpdateById(record)}>反审核</SActionBtn> // auth='antiAuditBtn'
                      <SActionBtn onClick={() => onEdit(record, true)}>
                          编辑
                      </SActionBtn>
                    ) : null}
                    {['-1', '2', '3'].includes(record.state) ? (
                      <>
                        {/* <SActionBtn title="是否提交审核？" confirm
                          onClick={() => onApply(record)} okText="是" cancelText="否">提交审核</SActionBtn> */}
                        <SActionBtn onClick={() => onApply(record)}>提交审核</SActionBtn>
                        <SActionBtn onClick={() => onEdit(record, false)}>
                          编辑
                        </SActionBtn>
                        <SActionBtn danger onClick={() => onDelete(record)}>删除</SActionBtn>
                      </>
                    ) : null}
                  </STableActions>
                );
              },
              fixed: 'right',
            },
          ],
          search: [
            {
              name: 'state',
              label: '状态',
              itemType: 'select',
              data: [
                { label: '未提审核', key: -1 },
                { label: '审核中', key: 0 },
                { label: '审核通过', key: 1 },
                { label: '审核不通过', key: 2 },
              ],
            },
            { name: 'companyFullName', label: '财务主体' },
          ],
          footer: [
            {
              label: '新增',
              type: 'primary',
              events: ['onClick:onAdd'],
            },
          ],
        }}
        ref={listRef}
        {...extension}
      />
      {/* <EditModal
        title={state.editTitle}
        visible={state.editVisible}
        onOk={onSubmitOk}
        onClose={() => setState({ editVisible: false })}
        data={state.editItem}
        companyList={state.companyList}
        taxPayerTypeList={state.taxPayerTypeList}
        financialOrgList={state.financialOrgList}
        disabled={state.formDisabled}
      /> */}
      <SDrawer
        title={state.editTitle}
        width="50%"
        isHideResetBtn={false}
        footer={!state.formDisabled ?[
          <Button onClick={() => setState({ editVisible: false })}>取消</Button>,
          <Button type='primary' style={{ marginLeft: 10 }} loading={state.submitLoading} onClick={onSubmitOk}>提交</Button>
        ] : []}
        open={state.editVisible}
        onClose={() => setState({ editVisible: false })}
        destroyOnClose
      >
        <AddOrEditForm ref={childRef} disabled={state.formDisabled} authVisible={state.authVisible}
        data={state.editItem}
        companyList={state.companyList}
        taxPayerTypeList={state.taxPayerTypeList}
        financialOrgList={state.financialOrgList}/>
      </SDrawer>
    </>
  );
}

const PageKeepAlive = (props: any) => {
  const location = useLocation()
  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <SBack title="财务组织管理" />
      <CompanyApply {...props} />
    </KeepAlive>
  );
};

export default PageKeepAlive;
